export default __webpack_public_path__ + "static/media/smile4.e42dfd64.jpg";